import { formatBytes } from './file-utils'

/** Entitlement feature keys whose limitValue is measured in bytes. */
export const BYTE_LIMIT_FEATURE_KEYS = new Set(['FILE_UPLOAD_SIZE_LIMIT'])

/** Entitlement feature keys that are simple on/off flags (limitValue "true"/"false"). */
export function isBooleanLimit(limitType: string): boolean {
  return limitType === 'BOOLEAN'
}

export function isByteLimit(featureKey: string): boolean {
  return BYTE_LIMIT_FEATURE_KEYS.has(featureKey)
}

/** Formats an entitlement limit for display ("Unlimited", "10.0 GB", "50"). */
export function formatLimitValue(featureKey: string, limitValue: string | number): string {
  if (isByteLimit(featureKey)) {
    const bytes = Number(limitValue)
    if (bytes === -1) return 'Unlimited'
    return formatBytes(bytes)
  }
  if (String(limitValue) === '-1') return 'Unlimited'
  return String(limitValue)
}

/** Numeric limit used by progress meters (-1 becomes Infinity for a full bar). */
export function numericLimit(limitValue: string | number): number {
  const value = Number(limitValue)
  return Number.isFinite(value) && value !== -1 ? value : Infinity
}

/** Formats a usage counter for display. */
export function formatUsageValue(featureKey: string, value: number): string {
  if (value < 0) return '—'
  return isByteLimit(featureKey) ? formatBytes(value) : String(value)
}
